Ext.define('SA.view.mapexport.UnitsField', {
    alias: 'widget.export-units-field',
    extend: 'SA.view.NumberField',

    baseCls: 'sa-export-unitsfield',
    childEls: ['unitsEl'],
    minValue: 0,
    units: 'pixels',

    initComponent() {
        this.afterSubTpl = '</td><td id="' + this.id + '-unitsEl" class="sa-export-unitsfield-units">';

        this.callParent();
    },

    afterRender() {
        var units = this.units;

        this.callParent();

        if (units) {
            this.setUnits(units);
        }
    },

    setUnits(units) {
        var unitsEl = this.unitsEl;

        this.units = units;

        if (unitsEl) {
            unitsEl.update(units);
            unitsEl.setWidth(unitsEl.getTextWidth() + unitsEl.getFrameWidth('lr'));
        }
    }
});